import { forwardRef } from "react";
import { formatSalesValue } from "../../utils/formatUtils";
import { ToWords } from 'to-words';
import { adToBs } from '@sbmdkl/nepali-date-converter';
const PrintableInvoice = forwardRef(({ billInfo, billInfoList, logoSrc }, ref) => {
    const address = sessionStorage.getItem('selectedAddress');
    const company = sessionStorage.getItem('selectedCompany');
    const pan_no = sessionStorage.getItem('selectedPan');
    const phone = sessionStorage.getItem('selectedPhone');

    const toWords = new ToWords({
        localeCode: 'en-IN',
        converterOptions: {
            currency: true,
            ignoreDecimal: false,
            ignoreZeroCurrency: false,
            doNotAddOnly: false,
            currencyOptions: {
                name: 'Rupee',
                plural: 'Rupees',
                symbol: '₹',
                fractionalUnit: {
                    name: 'Paisa',
                    plural: 'Paise',
                    symbol: '',
                },
            },
        }
    });

    const taxable_total = billInfoList.reduce((sum, item) => sum + Number(item.total), 0);
    const round_off = Number(billInfo.total) - Number(taxable_total) - Number(billInfo.vat);

    return (
        <div ref={ref} className="p-6 w-[700px] font-sans text-black mx-auto">
            <div className="text-center">
                <div className="flex justify-center">
                    <img src={logoSrc} alt="Logo" className="h-28" />
                </div>

                <h2 className="font-bold text-xl underline decoration-2 underline-offset-4">{company}</h2>

                <div className="text-sm mt-1 space-y-0">
                    <div>{address}</div>
                    {pan_no && (
                        <div>PAN No : {pan_no}</div>
                    )}
                    {phone && (
                        <div>Phone No: {phone} </div>
                    )}
                </div>
            </div>

            <h4 className="text-sm text-center font-bold underline decoration-2 underline-offset-4">
                TAX INVOICE
            </h4>

            <div className="flex justify-between mt-2 text-sm">
                <div>
                    <div>Bill No : {billInfo.bill_no}</div>
                    <div>Table No : {billInfo.Table_No}</div>
                    <div>Customer Name : {billInfo.GuestName || 'N/A'}</div>
                    <div>PAN No : {billInfo.guest_pan || 'N/A'}</div>
                </div>
                <div>
                    <div>Employee : {billInfo.employee}</div>
                    <div>Transaction Date : {billInfo.Date}</div>
                    <div>Invoice Issue Date : {billInfo.Date}</div>
                    <div>Nepali Miti : {billInfo.Date ? adToBs(billInfo.Date) : 'N/A'}</div>
                </div>
            </div>

            <div className="font-bold text-center text-sm">
                Payment Mode: {billInfo.PaymentMode}
            </div>

            <div className="border-b-2 border-t-2 border-black h-2 my-1"></div>

            <table className="w-full text-xs border-none text-left">
                <thead>
                    <tr className="border-b-2 border-black">
                        <th>HS Code</th>
                        <th>Item Name</th>
                        <th>Rate</th>
                        <th>Qty</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {billInfoList.map((item, index) =>
                        item.item_description ? (
                            <tr key={index} className="mb-1">
                                <td className="align-top">{item.HsCode}</td>
                                <td className="align-top">
                                    {item.itemName}
                                    <div className="text-xs my-3">
                                        {item.item_description?.split("\n").map((line, idx) => (
                                            <p key={idx}>{line}</p>
                                        ))}
                                    </div>
                                </td>
                                <td className="align-top">{formatSalesValue(item.itemrate)}</td>
                                <td className="align-top">{item.Quantity}</td>
                                <td className="align-top">{formatSalesValue(item.total)}</td>
                            </tr>
                        ) : (
                            <tr key={index}>
                                <td className="align-top">{item.HsCode}</td>
                                <td className="align-top">{item.itemName}</td>
                                <td className="align-top">{formatSalesValue(item.itemrate)}</td>
                                <td className="align-top">{item.Quantity}</td>
                                <td className="align-top">{formatSalesValue(item.total)}</td>
                            </tr>
                        )
                    )}
                    <tr className="font-semibold border-t-2 border-black">
                        <td colSpan={3}></td>
                        <td className="pt-2">
                            {billInfoList.reduce((sum, item) => sum + Number(item.Quantity), 0)}
                        </td>
                        <td className="pt-2">
                            {formatSalesValue(taxable_total)}
                        </td>
                    </tr>
                </tbody>
            </table>

            <div className="my-2 text-sm">
                <div>Discount : None</div>
                <div>Taxable Amount : {formatSalesValue(taxable_total)}</div>
                <div>Tax Amount (VAT) : {formatSalesValue(billInfo.vat)}</div>
                {round_off !== 0 && (
                    <div className="underline text-xs font-bold">Rounded Off : {Math.abs(Number(round_off) || 0).toFixed(2)}</div>
                )}
            </div>

            <div className="flex justify-between text-sm">
                <div className="font-bold uppercase underline">Grand Total: {formatSalesValue(billInfo.total)}</div>
                <div>IN WORDS : {toWords.convert(Number(billInfo.total) || 0)}</div>
            </div>

            <div className="border-b-4 border-black mt-1" />
        </div>
    );
});

export default PrintableInvoice;
